import { render, staticRenderFns } from "./StatUserEmail.vue?vue&type=template&id=1e89c036&"
import script from "./StatUserEmail.vue?vue&type=script&lang=js&"
export * from "./StatUserEmail.vue?vue&type=script&lang=js&"
import style0 from "./StatUserEmail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports